import { useState, useEffect } from "react"

import { moduleCategories } from "./utils"

const useStockModulesDB = (firebase, subdomainAudienceType, schoolCode) => {
  const [stockModules, setStockModules] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!firebase) {
      setIsLoading(false)
      return
    }

    let isMounted = true

    const fetchStockModules = async () => {
      try {
        const res = await firebase.getAllStockModules(schoolCode)
        let modules = res.data
        if (subdomainAudienceType === "ADULT") {
          const k12CategoryNames = moduleCategories.filter(cat => cat.type === "K-12").map(cat => cat.name)
          modules = modules.filter((module) =>
            !k12CategoryNames.includes(module.category)      
          )
        }
        if (isMounted) {
          setStockModules(modules)
        }
      } catch (err) {
        if (isMounted) {
          setError(err)
        }
      } finally {
        if (isMounted) {
          setIsLoading(false)
        }
      }
    }

    fetchStockModules()

    return () => {
      isMounted = false
    }
  }, [firebase, subdomainAudienceType, schoolCode])

  return { stockModules, isLoading, error }
}

export default useStockModulesDB